import { useState } from 'react'
import { deleteFile, downloadUrl } from '@/api/upload'
import { fmtBytes, KIND_LABEL } from '@/lib/format'
import { saveUrl } from '@/lib/zip'
import type { FileItem } from '@/lib/types'

interface Props {
  files: FileItem[]
  canDelete?: boolean
  onChanged?: () => void
  showKind?: boolean
  emptyText?: string | null
  downloadable?: boolean
  disabled?: boolean
}

/** Compact list of uploaded files with download and (optionally) delete. */
export function FileList({ files, canDelete = false, onChanged, showKind = false, emptyText = null, downloadable = true, disabled = false }: Props) {
  const [error, setError] = useState<string | null>(null)
  if (files.length === 0) return emptyText ? <p className="muted small">{emptyText}</p> : null
  return (
    <><ul className="filelist">
      {files.map((f) => (
        <li key={f.file_id}>
          <span style={{ flex: 1, minWidth: 0 }}>
            {showKind && <span className="muted small">{KIND_LABEL[f.kind]} · </span>}
            {downloadable ? <button className="link" disabled={disabled} onClick={async () => { if (disabled) return; try { setError(null); saveUrl(await downloadUrl(f.task_id, f.file_id)) } catch (e) { setError((e as Error).message) } }}>{f.filename}</button> : <span>{f.filename}</span>}
            <span className="muted small"> {fmtBytes(f.size)}</span>
            {f.description && <div className="muted small">{f.description}</div>}
          </span>
          {f.status !== 'uploaded' && <span className={`chip ${f.status === 'invalid' ? 'err' : 'warn'}`}>{f.status === 'invalid' ? 'invalid' : 'incomplete'}</span>}
          {canDelete && <button className="ghost sm" disabled={disabled} onClick={async () => { if (disabled) return; try { setError(null); await deleteFile(f.task_id, f.file_id, f.kind); onChanged?.() } catch (e) { setError((e as Error).message) } }}>Remove</button>}
        </li>
      ))}
    </ul>{error && <p className="field-error">{error}</p>}</>
  )
}
